{
	"name": "@cloudillo/formillo-app",
	"version": "0.8.20",
	"private": true,
	"description": "Formillo survey app",
	"type": "module",
	"main": "src/index.js",
	"scripts": {
		"l-scan": "i18next-scanner --config src/i18n/scanner.config.cjs",
		"ts": "tsgo --noEmit",
		"ts-watch": "tsgo --noEmit --watch",
		"build": "pnpm run ts && cross-env NODE_ENV=production node esbuild.config.js",
		"watch": "node esbuild.config.js --watch",
		"clean": "rimraf .cache dist/assets-*"
	},
	"author": "Szilárd Hajba <szilu@cloudillo.org",
	"license": "LGPL-3.0-or-later",
	"devDependencies": {
		"@cloudillo/core": "workspace:^",
		"@cloudillo/fonts": "workspace:^",
		"@cloudillo/react": "workspace:^",
		"@symbion/opalui": "^0.16.0",
		"@symbion/runtype": "^1.3.1",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"cross-env": "^10.1.0",
		"dayjs": "^1.11.23",
		"esbuild": "^0.28.2",
		"i18next": "^26.5.2",
		"i18next-browser-languagedetector": "^8.2.1",
		"i18next-scanner": "^4.6.0",
		"i18next-scanner-typescript": "^1.2.1",
		"react": "19.3.1",
		"react-dom": "19.3.1",
		"react-i18next": "^17.1.0",
		"react-router-dom": "^7.18.4",
		"rimraf": "^6.1.3",
		"tslib": "^2.8.1",
		"typescript": "^7.0.2"
	}
}
